import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { ShortDoorReportDocument } from '../../../../models/production/shared/short-door-report-document';

export const ShortDoorReport = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setIsOpen(false);
    };

    /**
     * runs the short door report
     */
    const runReport = () => {
        const today = new Date();
        const req = new ShortDoorReportDocument(today);
        dispatch(getDocumentHelper(req));
        onCloseClick();
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Short Door Report</h3>
                                <p>Obtain a list of short doors in production</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Short Door Report</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p className="callout">
                                Get a full export in Excel format of all the short doors in the system.
                            </p>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="shortDoorNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="shortDoorYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
